import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCompassPointer: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="compass-pointer, arrow, route"><path d="M9.46377 3.53328C10.4685 1.37956 13.5313 1.3795 14.536 3.53328L20.745 16.8477C21.8731 19.2672 19.2953 21.7415 16.9237 20.5157L12.5517 18.2559C12.2057 18.0772 11.7941 18.0773 11.4481 18.2559L7.07608 20.5157C4.70455 21.7415 2.12666 19.2672 3.25479 16.8477L9.46377 3.53328Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCompassPointer;
